<template>
  <div>
    <el-dialog
      title="设置"
      :visible.sync="showDialog"
      width="40%"
      @close="handleClose"
    >
      <el-form
        style="margin-left:.18rem"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="是否开启自动审核：" prop="isAutoAudit">
          <el-switch
            :disabled="isRead"
            v-model="ruleForm.isAutoAudit"
          ></el-switch>
        </el-form-item>
        <!-- <div class="form-tip-text">
          开启后用户可在手机端提交返校预约申请
        </div> -->
        <el-form-item  v-show="ruleForm.isAutoAudit" label="申请返校天数：" prop="autoAuditDay">
          <div style="display: flex;">
            <span>小于等于</span>
            <el-input
              :disabled="isRead"
              type="number"
              size="medium"
              style="width:100px;margin: 0 10px;"
              v-model.number="ruleForm.autoAuditDay"
              placeholder="请输入天数"
            />
            <span>天&nbsp;时系统自动通过</span>
          </div>
        </el-form-item>
        <!-- <el-form-item label="预约日期规则：" required prop="isDayOfWeek"> -->
        <el-form-item label="预约日期规则："  >
          <el-switch
            :disabled="isRead"
            v-model="ruleForm.isDayOfWeek"
          ></el-switch>
        </el-form-item>
        <el-form-item
          v-show="ruleForm.isDayOfWeek"
          label="预约日期设置："
          prop="dayOfWeekArray"
        >
          <div style="display: flex;">
            <span>每周</span>
            <el-select
              :disabled="isRead"
              size="medium"
              clearable
              multiple
              collapse-tags
              style="width:160px;margin: 0 10px"
              v-model="ruleForm.dayOfWeekArray"
              placeholder="请选择"
            >
              <el-option
                v-for="item in weekOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span>可预约</span>
          </div>
        </el-form-item>
        <el-form-item v-show="ruleForm.isDayOfWeek" label="申请返校天数：" prop="returnSchoolDays">
          <div style="display: flex;">
            <span>至多可预约未来</span>
            <el-input
              :disabled="isRead"
              type="number"
              size="medium"
              style="width:100px;margin:0 10px;"
              v-model.number="ruleForm.returnSchoolDays"
              placeholder="请输入天数"
            />
            <span>天内的返校申请</span>
          </div>
        </el-form-item>
        <el-form-item label="是否开启提前预约：" prop="isBefore">
          <el-switch :disabled="isRead" v-model="ruleForm.isBefore"></el-switch>
        </el-form-item>
        <el-form-item
          v-show="ruleForm.isBefore"
          label="用户需要提前"
          prop="beforeDay"
        >
          <div style="display: flex;">
            <el-input
              :disabled="isRead"
              size="medium"
              style="width:140px;margin: 0 10px;"
              v-model.number="ruleForm.beforeDay"
              placeholder="请输入天数"
            />
            <span>天提交预约申请</span>
          </div>
        </el-form-item>
        <el-form-item label="是否开启核验二维码：" prop="isVerify">
          <el-switch :disabled="isRead" v-model="ruleForm.isVerify"></el-switch>
        </el-form-item>
        <div class="form-tip-text" v-if="ruleForm.isVerify">
          二维码核验口令规则：当前年-月-日，例:20250109
        </div>
        <el-form-item style="margin-top: 20px;" v-if="!isRead">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetReturnSchoolPrebookSetInfoApi,
  GetReturnSchoolPrebookSetApi,
  SetReturnSchoolPrebookApi
} from "@/request/requestApi.js";

export default {
  data() {
    return {
      dayOptions: [
        { value: 0, label: "小于" },
        { value: 1, label: "大于" }
      ],
      weekOptions: [
        { value: "1", label: "周一" },
        { value: "2", label: "周二" },
        { value: "3", label: "周三" },
        { value: "4", label: "周四" },
        { value: "5", label: "周五" },
        { value: "6", label: "周六" },
        { value: "0", label: "周日" }
      ],
      ruleForm: {
        id: "",
        isOpen: true,
        isAutoAudit: false,
        autoAuditDay: 0,
        returnSchoolDays: 0,
        isDayOfWeek: false,
        dayOfWeek: "",
        dayOfWeekArray: [],
        isBefore: false,
        beforeDay: 0,
        isVerify: false
      },
      rules: {
        autoAuditDay: [
          { required: true, message: "请填写申请返校天数", trigger: "blur" },
          {
            type: "number",
            min: 1,
            message: "请输入合规天数",
            trigger: "blur"
          },
          { validator: this.validatePositiveInteger, trigger: "blur" }
        ],
        returnSchoolDays: [
          { required: true, message: "请填写天数", trigger: "blur" },
          {
            type: "number",
            min: 1,
            message: "请输入合规天数",
            trigger: "blur"
          },
          { validator: this.validatePositiveInteger, trigger: "blur" }
        ],
        isDayOfWeek: [
          { required: true, message: "请选择预约日期规则", trigger: "change" }
        ]
      }
    };
  },
  watch: {
    "ruleForm.isDayOfWeek": function(val) {
      if (!val) {
        // 隐藏时移除 dayOfWeekArray 的验证规则
        delete this.rules.dayOfWeekArray;
      } else {
        // 显示时添加 dayOfWeekArray 的验证规则
        this.$set(this.rules, "dayOfWeekArray", [
          { required: true, message: "请选择可预约的天数", trigger: "change" }
        ]);
      }
    },
    "ruleForm.isBefore": function(val) {
      if (!val) {
        // 隐藏时移除 beforeDay 的验证规则
        delete this.rules.beforeDay;
      } else {
        // 显示时添加 beforeDay 的验证规则
        this.$set(this.rules, "beforeDay", [
          {
            required: true,
            message: "请填写用户需要提前的天数",
            trigger: "blur"
          },
          {
            type: "number",
            min: 1,
            message: "天数不合规，请检查",
            trigger: "blur"
          }
        ]);
      }
    },
    showDialog(val) {
      // 当 showDialog 为 true 时调用获取数据的方法
      if (val) {
        this.getReturnSchoolPrebookSet();
      }
    }
  },
  created() {
    // this.getReturnSchoolPrebookSet();
  },
  methods: {
    validatePositiveInteger(rule, value, callback) {
      if (!Number.isInteger(value)) {
        callback(new Error("请输入合规天数"));
      } else {
        callback();
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 在这里执行提交逻辑，例如调用 SetReturnSchoolPrebookApi
          this.setReturnSchoolPrebook();
        } else {
          console.log("验证失败!");
          return false;
        }
      });
    },
    async setReturnSchoolPrebook() {
      let res = await SetReturnSchoolPrebookApi(this.ruleForm);
      if (res.succeed) {
        this.$message.success("操作成功！");
        this.handleClose();
      }
    },
    async getReturnSchoolPrebookSet() {
      if (!this.isRead) {
        let res = await GetReturnSchoolPrebookSetApi();
        if (res.succeed) {
          this.ruleForm.id = res.data.id;
          this.ruleForm.isOpen = res.data.isOpen;
          this.ruleForm.isAutoAudit = res.data.isAutoAudit;
          this.ruleForm.autoAuditDay = res.data.autoAuditDay;
          this.ruleForm.returnSchoolDays = res.data.returnSchoolDays;
          this.ruleForm.isDayOfWeek = res.data.isDayOfWeek;
          this.ruleForm.dayOfWeek = res.data.dayOfWeek;
          this.ruleForm.dayOfWeekArray = res.data.dayOfWeekArray;
          this.ruleForm.isBefore = res.data.isBefore;
          this.ruleForm.beforeDay = res.data.beforeDay;
          this.ruleForm.isVerify = res.data.isVerify;
        }
      } else {
        let res = await GetReturnSchoolPrebookSetInfoApi({ Id: this.schoolId });
        if (res.succeed) {
          this.ruleForm.id = res.data.id;
          this.ruleForm.isOpen = res.data.isOpen;
          this.ruleForm.isAutoAudit = res.data.isAutoAudit;
          this.ruleForm.autoAuditDay = res.data.autoAuditDay;
          this.ruleForm.returnSchoolDays = res.data.returnSchoolDays;
          this.ruleForm.isDayOfWeek = res.data.isDayOfWeek;
          this.ruleForm.dayOfWeek = res.data.dayOfWeek;
          this.ruleForm.dayOfWeekArray = res.data.dayOfWeekArray;
          this.ruleForm.isBefore = res.data.isBefore;
          this.ruleForm.beforeDay = res.data.beforeDay;
          this.ruleForm.isVerify = res.data.isVerify;
        }
      }
    },

    handleClose() {
      // this.resetForm("ruleForm");
      this.$emit("closeSetDialog");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    isRead: {
      type: Boolean,
      default: false
    },
    schoolId: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.form-tip-text {
  font-size: 12px;
  color: #ff4a4a;
  margin-bottom: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/view/backSchool/components/setDialog.vue